import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../containers/Layout';
import { GeneralError } from './GeneralError';
export const ErrorPageContent = ({ code, match }) => {
    const { t } = useTranslation();
    const codeWithDefault = code ? code : 404;
    return _jsx(Layout, { title: t(`httpErrors.${codeWithDefault}title`), match: match, children: _jsx(GeneralError, { code: codeWithDefault }) });
};
export default ErrorPageContent;
